import { gsap } from "gsap";

(function () {

	const filternav = document.querySelector('#filter-nav');
	const toggleBtn = document.querySelector('#filter-toggle');
    const toggleBtnClose = document.querySelector('#filter-toggle-close');
 	const menu = document.querySelector('#mobile-filter-content');

	const mobileAnimation = gsap.from('#mobile-filter-content a, #accordion-mob-flush ul h2 button, #mobile-filter-content ul li span', {
		opacity: 0,
		y: 20,
		stagger: 0.02,
		duration: 0.5,
	});
	
	if(toggleBtn) {
		toggleBtn.addEventListener('click', () => {
			menu.classList.toggle('hidden');
				if(filternav){
					filternav.classList.add('bg-white','drop-shadow-sm');
				}
				mobileAnimation.restart();
		});
	}

	if(toggleBtnClose){
		toggleBtnClose.addEventListener('click', () => {
			menu.classList.toggle('hidden');
			toggleBtnClose.classList.add('open');
			if (toggleBtnClose.classList.contains("open")) {
				mobileAnimation.restart();
			}
		});
	}
})();